var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"d-flex align-items-stretch",attrs:{"cols":"12"}},[_c('BasicNavbar')],1),_c('b-col',{staticClass:"d-flex align-items-stretch",attrs:{"cols":"12"}},[_c('CustomNavbarToggle')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }